export enum Classification {
    UNATTENDED_BICYCLE = "unattended_bicycle",
    ARRIVAL = "arrival",
    DEPARTURE = "departure",
    VEHICLE = "vehicle",
    PERSON = "person",
}
